/**
 * 解决方案模板配置
 * 基于智慧通行系统解决方案V2.1设计的通用模板
 */

// 解决方案基础字段模板
export const solutionBaseTemplate = {
  // 基本信息
  title: '',
  category: '',
  description: '',
  briefDescription: '',
  imageUrl: '',
  
  // 核心特点标签
  features: [
    { id: 1, name: '专业定制' },
    { id: 2, name: '高效可靠' },
    { id: 3, name: '技术领先' },
    { id: 4, name: '服务完善' }
  ],
  
  // 核心优势
  advantages: [],
  
  // 应用场景
  applicationScenarios: [],
  
  // 技术规格
  technicalSpecs: {
    systemArchitecture: '',
    networkTopology: '',
    hardwareRequirements: [],
    softwareRequirements: [],
    performanceIndicators: []
  },
  
  // 实施方案
  implementationPlan: {
    phases: [],
    timeline: '',
    deliverables: [],
    milestones: []
  },
  
  // 服务支持
  serviceSupport: {
    installation: '',
    training: '',
    maintenance: '',
    warranty: ''
  },
  
  // 成功案例
  successCases: [],
  
  // 相关文档
  documents: []
};

// 智慧通行系统解决方案模板
export const smartAccessTemplate = {
  ...solutionBaseTemplate,
  title: '大型高端社区智慧通行系统组网全面解决方案',
  category: '智慧通行',
  description: `本解决方案针对大型高端社区的智慧通行需求，提供全面的组网解决方案。
系统采用先进的物联网技术、人工智能技术和云计算技术，实现社区通行的智能化管理。
通过多种识别方式的融合应用，为居民提供便捷、安全、高效的通行体验。`,
  
  advantages: [
    '多重身份识别技术融合，支持人脸识别、车牌识别、门禁卡等多种方式',
    '云端智能管理平台，实现远程监控和数据分析',
    '高度集成化设计，降低部署和维护成本',
    '可扩展架构，支持社区规模的灵活扩展',
    '7×24小时专业技术支持服务'
  ],
  
  applicationScenarios: [
    '大型住宅社区主入口通行管理',
    '高端别墅区多层级安全管控',
    '商业综合体人车分流管理',
    '写字楼智能访客管理系统',
    '学校园区安全通行管理'
  ],
  
  technicalSpecs: {
    systemArchitecture: '分布式云边协同架构',
    networkTopology: '星型拓扑结构，支持有线/无线混合组网',
    hardwareRequirements: [
      '智能通行闸机：支持人脸识别、刷卡、二维码等多种通行方式',
      '高清摄像头：200万像素，支持夜视功能',
      '车牌识别设备：识别准确率≥99.5%',
      '网络设备：千兆交换机、无线AP等',
      '服务器：云端部署或本地化部署'
    ],
    softwareRequirements: [
      '智慧通行管理平台',
      '移动端APP应用',
      '数据分析系统',
      '报警联动系统'
    ],
    performanceIndicators: [
      '人脸识别准确率：≥99.7%',
      '车牌识别准确率：≥99.5%',
      '通行速度：≤2秒/人',
      '系统可用性：≥99.9%',
      '并发处理能力：≥1000人次/小时'
    ]
  },
  
  implementationPlan: {
    phases: [
      {
        name: '需求调研与方案设计',
        duration: '1-2周',
        description: '现场勘察、需求分析、方案设计'
      },
      {
        name: '设备采购与安装',
        duration: '2-3周',
        description: '设备采购、现场安装、网络布线'
      },
      {
        name: '系统调试与测试',
        duration: '1周',
        description: '系统调试、功能测试、性能优化'
      },
      {
        name: '培训与验收',
        duration: '1周',
        description: '用户培训、系统验收、正式上线'
      }
    ],
    timeline: '总体实施周期：5-7周',
    deliverables: [
      '系统设计方案',
      '设备安装清单',
      '系统操作手册',
      '培训材料',
      '验收报告'
    ],
    milestones: [
      '方案确认',
      '设备到货',
      '安装完成',
      '调试通过',
      '验收合格'
    ]
  },
  
  serviceSupport: {
    installation: '提供专业的现场安装服务，确保设备正确安装和调试',
    training: '提供系统操作培训，包括管理员培训和用户使用培训',
    maintenance: '提供7×24小时技术支持，定期系统维护和升级服务',
    warranty: '硬件设备提供2年质保，软件系统提供1年免费升级服务'
  },
  
  successCases: [
    {
      name: '某高端住宅社区',
      description: '为1000户居民提供智慧通行服务，显著提升通行效率和安全性',
      benefits: ['通行效率提升60%', '安全事件减少80%', '管理成本降低40%']
    },
    {
      name: '某商业综合体',
      description: '实现人车分流智能管理，日均通行量10000人次',
      benefits: ['通行速度提升50%', '管理效率提升70%', '用户满意度95%']
    }
  ]
};

// 解决方案类别定义
export const solutionCategories = [
  { value: 'smart-access', label: '智慧通行', labelEn: 'Smart Access', template: smartAccessTemplate },
  { value: 'smart-parking', label: '智慧停车', labelEn: 'Smart Parking', template: solutionBaseTemplate },
  { value: 'smart-security', label: '智慧安防', labelEn: 'Smart Security', template: solutionBaseTemplate },
  { value: 'smart-building', label: '智慧楼宇', labelEn: 'Smart Building', template: solutionBaseTemplate },
  { value: 'smart-community', label: '智慧社区', labelEn: 'Smart Community', template: solutionBaseTemplate }
];

// 获取指定类别的模板
export const getTemplateByCategory = (category) => {
  const categoryConfig = solutionCategories.find(cat => cat.value === category);
  return categoryConfig ? categoryConfig.template : solutionBaseTemplate;
};

// 创建新解决方案实例
export const createSolutionInstance = (category = 'smart-access') => {
  const template = getTemplateByCategory(category);
  return JSON.parse(JSON.stringify(template)); // 深拷贝
};

// 验证解决方案数据完整性
export const validateSolutionData = (solutionData) => {
  const errors = [];
  
  if (!solutionData.title) errors.push('标题不能为空');
  if (!solutionData.category) errors.push('类别不能为空');
  if (!solutionData.description) errors.push('描述不能为空');
  if (!solutionData.advantages || solutionData.advantages.length === 0) {
    errors.push('核心优势不能为空');
  }
  if (!solutionData.applicationScenarios || solutionData.applicationScenarios.length === 0) {
    errors.push('应用场景不能为空');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

export default {
  solutionBaseTemplate,
  smartAccessTemplate,
  solutionCategories,
  getTemplateByCategory,
  createSolutionInstance,
  validateSolutionData
};